import { useState, useContext } from "react";
import { AuthContext } from "../../Hooks/context/AuthContext";
import { useOTPService } from "../../api/apiEndpoints/AuthOTP";
import { useNavigate } from "react-router-dom";
import { useStatusToVerifyService } from "../../api/apiEndpoints/StatusToVerifyUserlastModified";
import { OTPVerifyContext } from "../context/OTPVeriryContext";
import { String } from "../../constants/Strings";
import { gaCustomEvent } from "../../logic/CommonFunctions";

const useOnboardingOTP = () => {
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [messageSet, setMessageSet] = useState({});
  const [snackbarOTPEnter, setSnackbarOTPEnter] = useState(false);
  const [resendEnable, setResendEnable] = useState(false);
  const [resendMessage, setResendMessage] = useState("");
  const [otpID, setOtpID] = useState("");
  const [timer, setTimer] = useState(30);

  const { setTokens } = useContext(AuthContext);
  const { sendOTP, verifyOTP } = useOTPService();
  const { getStatusOfUser } = useStatusToVerifyService();
  const { verifyData } = useContext(OTPVerifyContext);

  const navigate = useNavigate();
  const handleOTPChange = (otpValue) => {
    setOtp(otpValue);
  };
  const NavigateToScreen = (status) => {
    switch (status) {
      case 1:
        navigate(String.navigations.currentportfolio);

        break;
      case 2:
        navigate(String.navigations.monthlyincomeintroduction);
        break;
      case 3:
        navigate(String.navigations.fetchinfo);
        break;
      case 4:
        navigate(String.navigations.customerdashboard);
        break;
      case 5:
        navigate(String.navigations.customerdashboard);
        break;

      default:
        break;
    }
  };
  const statusToVerifyLastModified = async (userID, accessToken) => {
    const lastModified = await getStatusOfUser({ userId: userID }, accessToken);
    if (lastModified.response) {
      NavigateToScreen(lastModified.response.status);
    }
  };
  const handleSendOTP = async (payload) => {
    const ERROR_MESSAGES = {
      length: String.OnbordingStr.ERROR_MESSAGES.length,
      invalid: String.OnbordingStr.ERROR_MESSAGES.invalid,
      server: String.OnbordingStr.ERROR_MESSAGES.server,
    };

    try {
      const response = await sendOTP({ payload });
      setOtpID(response.response.otpId);
      return true;
    } catch (error) {
      setErrors({ server: error.message || ERROR_MESSAGES.server });
      return false;
    }
  };

  const handleAuthorize = async () => {
    gaCustomEvent(String.gaEventName.acrLogin, String.gaEventClickName.acrLoginAuthorise, verifyData.customerId);

    if (!otp) {
      setSnackbarOTPEnter(true);
      setMessageSet({ error: String.OnbordingStr.EnterOtp });
      return;
    } else if (otp.length !== 6) {
      setSnackbarOTPEnter(true);
      setMessageSet({ error: String.OnbordingStr.fourdigitErrorMessage });
      return;
    }
    const data = {
      otpId: otpID,
      otp: otp,
      userId: verifyData.customerId,
    };
    try {
      const response = await verifyOTP({ data });
      if (response && response.httpCode === 200) {
        const { accessToken, refreshToken } = response.response || {};
        if (accessToken && refreshToken) {
          setTokens({
            accessToken,
            refreshToken,
            userId: data.userId,
          });
        }
        setOpenSnackbar(true);
        setMessageSet({ message: response.message });
        // navigate("/currentportfolio");
        setTimeout(() => {
          setOpenSnackbar(false);
          // navigate(String.navigations.currentportfolio);
          statusToVerifyLastModified(data.userId, accessToken);
        }, 3000);

        return true;
      } else {
        setErrors({
          error: response.message || String.OnbordingStr.InvalidOTP,
        });
        setSnackbarOTPEnter(true);
        return false;
      }
    } catch (error) {
      setErrors({ server: String.OnbordingStr.errorWhileVerifyOTP });
      setSnackbarOTPEnter(true);
      return false;
    }
  };
  const resendOTP = async () => {
    const data = {
      userId: verifyData.customerId,
    };
    try {
      const response = await sendOTP({ payload: data });
      if (response.httpCode === 200) {
        startTimer();
        setResendEnable(true);
        setResendMessage(String.OnbordingStr.OTPresentsuccessfully);
      }
    } catch (error) {}
  };

  const startTimer = () => {
    let newIntervalId = null;
    if (newIntervalId) {
      clearInterval(newIntervalId); // Clear any existing interval
    }

    newIntervalId = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer > 0) {
          return prevTimer - 1;
        } else {
          clearInterval(newIntervalId); // Stop the timer when it reaches 0
          return 0;
        }
      });
    }, 1000);
  };
  return {
    otp,
    setOtp,
    errors,
    openSnackbar,
    setOpenSnackbar,
    messageSet,
    snackbarOTPEnter,
    resendEnable,
    setResendEnable,
    resendMessage,
    setResendMessage,
    setSnackbarOTPEnter,
    handleOTPChange,
    handleSendOTP,
    handleAuthorize,
    resendOTP,
    timer,
    setTimer,
    startTimer,
  };
};

export default useOnboardingOTP;
